// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementCampaignsDataFiltersResult = objectOf({
  filters: arrayOf(
    objectOf({
      id: string,
      value: anyOf(string, arrayOf(string)),
    })
  ),
});
